const routes = [
    {
        path: "/customer/budgets",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "customer_index",
        }
    },
    {
        path: "/customer/budgets/:id",
        component: () => import("../pages/PaymentDetail"),
        meta: {
          isAuthenticated: true,
          permission: "customerbudgetpayment_index"
        }
    },
];

export default routes;
